import React, { useEffect } from 'react';
import './ModalFatoRapido.css';

const ModalFatoRapido = ({ data, onClose }) => {
  useEffect(() => {
    // Prevenir scroll do body quando modal está aberto
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  if (!data) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        
        <div className="modal-header">
          <div 
            className="modal-image"
            style={{ backgroundImage: `url(${data.imagem_url})` }}
          >
            <div className="modal-image-overlay"></div>
          </div>
          <h2 className="modal-name">{data.nome}</h2>
        </div>

        <div className="modal-body">
          <div className="fato-label">FATO RÁPIDO</div>
          <p className="fato-texto">{data.fato_rapido}</p>

          {data.tags && data.tags.length > 0 && (
            <div className="tags-container">
              {data.tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag.replace(/_/g, ' ')}
                </span>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-continue" onClick={onClose}>
            Continuar Jogo
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalFatoRapido;
